<span class="clear-input">
  <i *ngIf="!searching" [ngClass]="optionsControl.value ? '' : 'hide-opacity'" class="bhi-times clear-icon"
     (click)="clearInput(optionInput, true)"></i>
  <input type="text" [placeholder]="placeholder" (click)="forceShowOptionsDropDown($event)"
         [matAutocomplete]="optionAuto"
         [formControl]="optionsControl" #optionInput [title]="titleTooltip">
  <span *ngIf="searching" class="input-loading-spinner spinner-border spinner-border-sm"></span>
</span>
<mat-autocomplete #optionAuto [displayWith]="optionDisplayValue.bind(this)" (optionSelected)="optionSelected($event)">
    <mat-option *ngFor="let optionItem of filteredOptions$ | async" [value]="optionItem.name">
        {{optionItem.label}} ({{optionItem.name}})
    </mat-option>
</mat-autocomplete>
